export const initialState = {};

export default initialState;
